import Request from "lib/request";

export const availability = (id) => {
  return Request({
    url: "dealer-availability/"+id,
    method: "get"
  });
};

export const sendOrder = (id,data) => {
  return Request({
    url: "submit/"+id,
    method: "post",
    data
  });
};
export const sendStockOrder = (id, data) => {
  return Request({
    url: "burse-orders/" + id,
    method: "post",
    data,
  });
};
export const getOrders =()=>{
  return Request({
    url: "orders",
    method: "get"
  });
}
export const getSecondPayments =()=>{
  return Request({
    url: "second-payments",
    method: "get"
  });
}
export const getCustomerFinances = () => {
  return Request({
    url: "customer-finances",
    method: "get",
  });
};
export const getStockOrders = () => {
  return Request({
    url: "burse-orders",
    method: "get",
  });
};
